var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "call-to-action shape bg-navy border-radius p-4",
      on: {
        click: function($event) {
          return _vm.open("/sign-up")
        }
      }
    },
    [_vm._m(0)]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "call-to-action__content" }, [
      _c("div", { staticClass: "call-to-action__heading mb-2" }, [
        _vm._v("Become a member today.")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "call-to-action__paragraph mb-12px" }, [
        _vm._v(
          "If you’re an EOD Technician or someone with a Technical\n            Interest then sign up today for access to additional technical information and downloadable\n            data."
        )
      ]),
      _vm._v(" "),
      _c("a", { staticClass: "btn-icon-text", attrs: { href: "/sign-up" } }, [
        _vm._v("Get started today "),
        _c("i", { staticClass: "icon icon__arrow-right" })
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d453350c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d453350c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/CallToAction.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-d453350c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/CallToAction.vue
// module chunks = 0 1